import { render, staticRenderFns } from "./MindsetEvaluation.vue?vue&type=template&id=3aaf5ff2&scoped=true"
import script from "./MindsetEvaluation.vue?vue&type=script&lang=js"
export * from "./MindsetEvaluation.vue?vue&type=script&lang=js"
import style0 from "./MindsetEvaluation.vue?vue&type=style&index=0&id=3aaf5ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf5ff2",
  null
  
)

export default component.exports